import './components/cta-block';
import "./components/lightbox";
import "./components/navigation";

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR');
    });
}

const dynamicDate = document.querySelector('[data-dynamic-date]');
if (dynamicDate) {
    const language = document.documentElement.lang;
    const now = new Date();
    dynamicDate.textContent = now.toLocaleDateString(language, { dateStyle: 'medium', });
    dynamicDate.setAttribute('datetime', now.toISOString().slice(0, 10));
}
